import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_get_inventory_by_license_plate_lot_by_project_idService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, ActiveAmount?: number, ActivePackagedAmount?: number, AllocatedAmount?: number, AllocatedPackagedAmount?: number, AvailableAmount?: number, AvailablePackagedAmount?: number, CurrentlyAvailableAmount?: number, CurrentlyAvailablePackagedAmount?: number, InactiveAmount?: number, InactivePackagedAmount?: number, IncomingAmount?: number, IncomingPackagedAmount?: number, SoftAllocatedAmount?: number, SoftAllocatedPackagedAmount?: number, SoftIncomingAmount?: number, SoftIncomingPackagedAmount?: number, TotalAmount?: number, TotalPackagedAmount?: number, WarehouseId?: number, LicensePlate?: { DimensionsUomId?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Location?: { Name?: string, Status?: { Name?: string } }, Status?: { Name?: string } } }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, ActiveAmount?: number, ActivePackagedAmount?: number, AllocatedAmount?: number, AllocatedPackagedAmount?: number, AvailableAmount?: number, AvailablePackagedAmount?: number, CurrentlyAvailableAmount?: number, CurrentlyAvailablePackagedAmount?: number, InactiveAmount?: number, InactivePackagedAmount?: number, IncomingAmount?: number, IncomingPackagedAmount?: number, SoftAllocatedAmount?: number, SoftAllocatedPackagedAmount?: number, SoftIncomingAmount?: number, SoftIncomingPackagedAmount?: number, TotalAmount?: number, TotalPackagedAmount?: number, WarehouseId?: number, LicensePlate?: { DimensionsUomId?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Location?: { Name?: string, Status?: { Name?: string } }, Status?: { Name?: string } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[], $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, ActiveAmount?: number, ActivePackagedAmount?: number, AllocatedAmount?: number, AllocatedPackagedAmount?: number, AvailableAmount?: number, AvailablePackagedAmount?: number, CurrentlyAvailableAmount?: number, CurrentlyAvailablePackagedAmount?: number, InactiveAmount?: number, InactivePackagedAmount?: number, IncomingAmount?: number, IncomingPackagedAmount?: number, SoftAllocatedAmount?: number, SoftAllocatedPackagedAmount?: number, SoftIncomingAmount?: number, SoftIncomingPackagedAmount?: number, TotalAmount?: number, TotalPackagedAmount?: number, WarehouseId?: number, LicensePlate?: { DimensionsUomId?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Location?: { Name?: string, Status?: { Name?: string } }, Status?: { Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectId?: number, materialId?: number, materialLookupCode?: string, warehouseIds?: number[]    }) {
      return false;
    }
}
